import axios from 'axios'
const { REACT_APP_API_BASE_URL } = process.env

const validateIban = ( iban: string ) => {
    const url = `${REACT_APP_API_BASE_URL}/iban/${iban}/validate`
    return axios.post(url).then(response => response,
    err => err)
}

export default validateIban